/*
*@Author: dcl
*@Description: 自营平台信息
*@Date: 2022-11-14 11:28:04
*/
<template>
    <div class="ico">
        <el-table :data="companyList" height="13.5rem" :header-cell-style="headerstyle" :cell-style="cellStyle"
            style="width: 98%">
            <el-table-column prop="name" label="平台名称" min-width="95" align="center"></el-table-column>
            <el-table-column prop="range" label="平台类型" min-width="95" align="center"></el-table-column>
            <el-table-column prop="website" label="平台网址" min-width="70" align="center"></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            companyList: [{
            //     name: "易龙兴保",
            //     range: "网站",
            //     website: "www.elongai.com"
            // },
            // {
                name: "易龙兴保",
                range: "网站",
                website: "www.elongai.cn"
            }
            ]
        };
    },
    methods: {
        headerstyle() {
            return "font-size: .67rem;font-weight: normal;background-color:#FAFAFA;color: #666666;";
        },
        cellStyle() {
            return "font-size: 0.53rem;color: #666666;";
        }
    }
};
</script>

<style scoped lang='less'>
.ico {
    margin-top: .73rem;
}
</style>



// WEBPACK FOOTER //
// src/view/Information/proprietary.vue